import { usePoMutation, confirmAuthCode } from '@gov-nx/api';

interface ConfirmAuthCodeProps {
	onSuccess?: (data: Awaited<ReturnType<typeof confirmAuthCode>>) => void;
}

export const useConfirmAuthCode = (props?: ConfirmAuthCodeProps) => {
	const mutation = usePoMutation({
		mutationFn: confirmAuthCode,
		onSuccess: (data) => {
			props?.onSuccess?.(data);
		},
		onError: () => {},
	});

	return mutation;
};
